export const FLAT_RATES_TEXT = Object.freeze({
  page: {
    title: 'Igualas',
    subtitle: 'Gestión operativa de negocios de iguala.',
  },
  modal: {
    flatRatePlan: {
      voucherType: {
        label: 'Tipo de comprobante *',
        placeholder: 'Selecciona tipo de comprobante',
      },
      box: {
        title: 'Importes de plan de pagos',
        subtitle: 'Configura periodicidad, impuestos y resumen de montos.',
      },
      frequency: {
        label: 'Frecuencia del plan de pagos',
        options: {
          unique: 'Único',
          monthly: 'Mensual',
          multiple: 'Múltiple',
        },
        paymentsCountLabel: 'Cantidad de planes de pago',
        paymentsCountPlaceholder: '1',
        firstInstallmentLabel: 'Primer mensualidad',
        firstInstallmentPlaceholder: 'Selecciona mes',
        periodicityLabel: 'Periodicidad del plan de pagos',
        periodicityPlaceholder: 'Selecciona periodicidad',
      },
      amounts: {
        subtotalLabel: 'Subtotal del plan *',
        percentageLabel: 'Porcentaje %',
      },
      warnings: {
        amountExceeded: (amount) => `Se ha superado el importe del negocio en: ${amount}`,
        amountSummary: (remaining, maxPerPlan) => `Importe del negocio disponible: ${remaining} | Máximo por plan: ${maxPerPlan}`,
        percentExceeded: (percent) => `Se ha superado el importe del negocio en: ${percent}%`,
        percentSummary: (remainingPercent, maxPercent) => `Importe del negocio disponible (%): ${remainingPercent}% | Máximo por plan (%): ${maxPercent}%`,
      },
      taxes: {
        title: 'Impuestos',
        subtitle: 'Selecciona el tipo de impuestos aplicables para este plan de pagos.',
        withoutTaxes: 'Sin impuestos',
        taxType: 'Tipo de impuestos',
        taxes: 'Impuestos',
        placeholders: {
          taxes: 'Selecciona impuestos',
          group: 'Selecciona grupo',
        },
        fallbackTaxLabel: ({ id }) => `Impuesto #${id}`,
        fallbackGroupLabel: 'Grupo',
        fallbackIndividualLabel: 'Individual',
      },
      schedule: {
        startDateLabel: 'Fecha de Inicio',
        invoiceDateLabel: 'Fecha de Facturación',
        paymentDateLabel: 'Fecha de pago',
        datePlaceholder: 'Selecciona fecha',
        todayButton: 'Hoy',
      },
      common: {
        noOption: 'Sin opción disponible',
      },
    },
  },
  tabs: {
    flatRates: 'Igualas',
    open: 'Abiertos',
    closed: 'Cerrados',
    canceled: 'Cancelados',
  },
  headerActions: {
    newFlatRate: 'Nueva iguala',
  },
  metrics: {
    activeFlatRates: 'IGUALAS ACTIVAS',
    recurringIncome: 'INGRESO MENSUAL RECURRENTE',
    pendingInvoices: 'FACTURAS PENDIENTES',
    pendingPayments: 'PAGOS PENDIENTES',
  },
  table: {
    loading: 'Cargando igualas...',
    empty: 'Sin igualas disponibles para los filtros seleccionados.',
    emptyOpen: 'Sin negocios abiertos para los filtros seleccionados.',
    emptyClosed: 'Sin negocios cerrados para los filtros seleccionados.',
    emptyCanceled: 'Sin negocios cancelados para los filtros seleccionados.',
    sortTitles: {
      month: 'Ordenar por mes',
      business: 'Ordenar por negocio',
      service: 'Ordenar por servicio',
      subtotal: 'Ordenar por subtotal',
      total: 'Ordenar por total',
      invoice: 'Ordenar por factura',
      payment: 'Ordenar por pago',
    },
    columns: {
      month: 'MES',
      business: 'NEGOCIO',
      service: 'SERVICIO',
      subtotal: 'SUBTOTAL',
      taxes: 'IMPUESTOS',
      total: 'TOTAL',
      invoice: 'FACTURA',
      payment: 'PAGO',
      status: 'ESTADO',
    },
    taxes: {
      transferred: 'Trasladados',
      withheld: 'Retenidos',
    },
    exchangeRatePrefix: 'TC:',
    links: {
      customerDetail: 'Ir al detalle del cliente',
      saleDetail: 'Ir al detalle del negocio',
      invoiceDetail: 'Ir al detalle de la factura',
      invoiceDefaultLabel: 'Ver factura',
    },
    actions: {
      issueInvoice: 'Facturar',
      issueSimpleNote: 'Nota simple',
      pay: 'Pagar',
      viewSale: 'Ver iguala',
      editSale: 'Editar iguala',
      changeStatus: 'Cambiar estado',
      more: 'Más acciones',
      delete: 'Eliminar',
    },
    status: {
      newFlatRate: 'Nueva Iguala',
      lastMonth: 'Último mes',
      fallback: '-',
    },
    payment: {
      fallbackReference: '-',
    },
  },
  confirms: {
    delete: {
      title: 'Eliminar iguala',
      subtitle: 'Esta acción eliminará la iguala seleccionada.',
      confirm: 'Eliminar',
      message: (saleName) => `Iguala: ${saleName}\n¿Deseas continuar con la eliminación?`,
      fallbackName: 'Sin nombre',
    },
    deletePaymentPlan: {
      title: 'Eliminar plan de pagos',
      subtitle: 'Esta acción eliminará el plan de pagos seleccionado.',
      confirm: 'Eliminar',
      message: (planName) => `Plan: ${planName}\n¿Deseas continuar con la eliminación?`,
      fallbackName: 'Plan de pagos',
    },
  },
  toasts: {
    newFlatRatePending: 'La creación de igualas desde este módulo se habilitará en el siguiente paso.',
    createSuccess: 'La iguala ha sido registrada correctamente.',
    createError: 'No fue posible registrar la iguala.',
    invoiceFlowPending: 'El flujo de nota simple de igualas se conectará en el siguiente paso.',
    payFlowPending: 'El flujo de pago de igualas se conectará en el siguiente paso.',
    businessStatusPending: 'Cambiar estado de igualas cerradas/canceladas estará disponible pronto.',
    statusOptionsLoadError: 'No fue posible cargar los estados de negocio.',
    statusUpdateError: 'No fue posible actualizar el estado del negocio.',
    statusUpdateSuccess: 'El estado del negocio ha sido actualizado correctamente.',
    paymentPlanDetailLoadError: 'No fue posible cargar el detalle del plan de pagos.',
    paymentPlanUpdateSuccess: 'Plan de pagos actualizado correctamente.',
    paymentPlanUpdateError: 'No se pudo guardar el plan de pagos.',
    loadRowsError: 'No fue posible cargar las igualas.',
    deleteError: 'No fue posible eliminar la iguala.',
    deleteSuccess: 'La iguala ha sido eliminada correctamente.',
  },
});
